import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Activity from "@mapmycustomers/shared/types/entity/Activity";
import User from "@mapmycustomers/shared/types/User";

import PreviewActivityListModal from "@app/component/PreviewActivityListModal";
import { getSelectedTypeData, getTotalrecordsByActivityType } from "@app/scene/home/store";
import { fetchSelectedActivityByTypesData } from "@app/scene/home/store/actions";
import { RootState } from "@app/store/rootReducer";

interface Props {
  dateRange: string;
  fetchSelectedActivityByTypesData: typeof fetchSelectedActivityByTypesData.request;
  onHide: () => void;
  pageSize: number;
  selectedActivityTypeId: Activity["id"];
  selectedTypeData: Activity[];
  title?: React.ReactNode;
  totalRecords: number;
  users: User[];
}

const RecordListByActivityTypeModal: React.FC<Props> = ({
  dateRange,
  fetchSelectedActivityByTypesData,
  onHide,
  pageSize,
  selectedActivityTypeId,
  selectedTypeData,
  title,
  totalRecords,
  users,
}) => {
  const [page, setPage] = useState<number>(1);
  useEffect(() => {
    fetchSelectedActivityByTypesData({
      assigneeIds: users.map(({ id }) => id),
      crmActivityTypeIds: selectedActivityTypeId,
      dateRange,
      page,
    });
  }, [fetchSelectedActivityByTypesData, users, dateRange, page, selectedActivityTypeId]);

  return (
    <>
      <PreviewActivityListModal
        activities={selectedTypeData}
        onHide={onHide}
        onPageChange={setPage}
        page={page}
        pageSize={pageSize}
        title={title}
        totalRecords={totalRecords}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  selectedTypeData: getSelectedTypeData(state),
  totalRecords: getTotalrecordsByActivityType(state),
});

const mapDispatchToProps = {
  fetchSelectedActivityByTypesData: fetchSelectedActivityByTypesData.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordListByActivityTypeModal);
